import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const cityList = createAsyncThunk('cityList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `city`,
            params: {
                'search': data?.search,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const cityListSlice = createSlice({
    name: 'cityList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(cityList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(cityList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default cityListSlice.reducer; 